module.exports = __webpack_public_path__ + "img/desc_bottom_zj4362.05b69983.png";